import { getAllCommissionPayouts } from "@/services/pricing-config.service";
import { useQuery } from "@tanstack/react-query";

export const useAllCommissionPayouts = (
  enabled = true,
  params = { page: 0, size: 10, search: "" },
  options = {},
) => {
  const queryKey = [
    "all-commission-payouts",
    params.page,
    params.size,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getAllCommissionPayouts(params),
    enabled,
    ...options,
  });
};
